module.exports = __webpack_public_path__ + "static/img/btn_floot_cta.13a0ade.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c13/btn_floot_cta.jpg
// module id = cRJX
// module chunks = 1